import axios from "@/plugins/axios";

let url = "/api/integrated-viewer/sales-dashboard";

/**
 * @typedef {object} $SalesDashboard
 *
 * @property {boolean} success
 * @property {"DAILY" | "WEEKLY" | "MONTHLY"} mode 요청한 기간 종류 그대로
 * @property {string} title 기간 제목 (YYYY.MM.DD ~ YYYY.MM.DD)
 * @property {string} startDate
 * @property {string} endDate
 *
 * @property {object} daehanbooks 나누리상품권 주문 매출 (결제완료 주문, 추천인 조건 없음)
 * @property {number} daehanbooks.total 쿠콘 + KG이니시스
 * @property {number} daehanbooks.checkpay 쿠콘
 * @property {number} daehanbooks.wpay KG이니시스
 * @property {object} daehanbooks.counts 결제완료 주문 건수
 * @property {number} daehanbooks.counts.total 쿠콘 + KG이니시스
 * @property {number} daehanbooks.counts.checkpay 쿠콘
 * @property {number} daehanbooks.counts.wpay KG이니시스
 *
 * @property {{ total: number } | null} paysolus 페이솔루스 매출. 나누리핀 호출이 실패하면 null
 * @property {true} [paysolusError] 나누리핀 호출이 실패했을 때만 붙는다(이때 paysolus 는 null)
 */

export const salesDashboard = {
    /**
     * @param {import("axios").AxiosRequestConfig} data params: { mode: "DAILY" | "WEEKLY" | "MONTHLY", date: "YYYY-MM-DD" }
     * @returns {Promise<$SalesDashboard>}
     */
    get(data) {
        return axios.get(url, data).then((result) => result.data);
    },
};

export default salesDashboard;
